import { Navigate, Outlet, useLocation } from 'react-router';
import { buildAuthHref, rememberAuthIntent } from './auth-intent';
import { useAuthStore } from './store';

function isDemoReaderIntent(pathname: string, search: string) {
  return pathname.startsWith('/reader/') && new URLSearchParams(search).get('demo') === 'reader';
}

export function RequireWebAuth() {
  const location = useLocation();
  const runtime = useAuthStore((s) => s.runtime);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isReady = useAuthStore((s) => s.isReady);

  if (!isReady) {
    return null;
  }

  if (runtime === 'web' && !isAuthenticated && !isDemoReaderIntent(location.pathname, location.search)) {
    const returnTo = `${location.pathname}${location.search}`;
    rememberAuthIntent(returnTo);
    return <Navigate to={buildAuthHref(returnTo)} replace />;
  }

  return <Outlet />;
}
